var map = {
	"./community_guideline_en_HK.md": 42,
	"./community_guideline_en_KH.md": 43,
	"./community_guideline_en_TH.md": 44,
	"./community_guideline_kh_KH.md": 45,
	"./community_guideline_th_TH.md": 46,
	"./community_guideline_zh-TW_HK.md": 47,
	"./delivery_terms_en.md": 48,
	"./easi6_booking_en.md": 49,
	"./easi6_booking_ko.md": 50,
	"./easi6_booking_zh-rCN.md": 51,
	"./easi6_booking_zh-rHK.md": 52,
	"./easi6_en.md": 53,
	"./easi6_ko.md": 54,
	"./easi6_platform_partner_en.md": 55,
	"./easi6_platform_partner_ko.md": 56,
	"./easi6_privacy_en.md": 57,
	"./easi6_privacy_ko.md": 58,
	"./easi6_rental_en.md": 59,
	"./easi6_rental_ko.md": 60,
	"./mvl_terms_en_SG.md": 61,
	"./mvltaxi_driver_terms_ko.md": 62,
	"./quiks_delivery_terms_en.md": 63,
	"./quiks_driver_terms_en.md": 64,
	"./quiks_privacy_en.md": 65,
	"./tada_delivery_terms_en.md": 66,
	"./tada_driver_codes_en_HK.md": 67,
	"./tada_driver_codes_en_KH.md": 68,
	"./tada_driver_codes_en_SG.md": 69,
	"./tada_driver_codes_en_TH.md": 70,
	"./tada_driver_codes_kh_KH.md": 71,
	"./tada_driver_codes_th_TH.md": 72,
	"./tada_driver_codes_zh-TW_HK.md": 73,
	"./tada_driver_privacy_en_HK.md": 74,
	"./tada_driver_privacy_en_KH.md": 75,
	"./tada_driver_privacy_en_SG.md": 76,
	"./tada_driver_privacy_en_TH.md": 77,
	"./tada_driver_privacy_kh_KH.md": 78,
	"./tada_driver_privacy_th_TH.md": 79,
	"./tada_driver_privacy_vn_VN.md": 80,
	"./tada_driver_privacy_zh-TW_HK.md": 81,
	"./tada_driver_terms_en_HK.md": 82,
	"./tada_driver_terms_en_KH.md": 83,
	"./tada_driver_terms_en_SG.md": 84,
	"./tada_driver_terms_en_TH.md": 85,
	"./tada_driver_terms_en_VN.md": 86,
	"./tada_driver_terms_kh_KH.md": 87,
	"./tada_driver_terms_th_TH.md": 88,
	"./tada_driver_terms_vn_VN.md": 89,
	"./tada_driver_terms_zh-TW_HK.md": 90,
	"./tada_privacy_en_HK.md": 91,
	"./tada_privacy_en_KH.md": 92,
	"./tada_privacy_en_SG.md": 93,
	"./tada_privacy_en_TH.md": 94,
	"./tada_privacy_kh_KH.md": 95,
	"./tada_privacy_th_TH.md": 96,
	"./tada_privacy_zh-TW_HK.md": 97,
	"./tada_terms_en_HK.md": 98,
	"./tada_terms_en_KH.md": 99,
	"./tada_terms_en_SG.md": 100,
	"./tada_terms_en_TH.md": 101,
	"./tada_terms_kh_KH.md": 102,
	"./tada_terms_th_TH.md": 103,
	"./tada_terms_vn_VN.md": 104,
	"./tada_terms_zh-TW_HK.md": 105,
	"./wallet_terms_en_KH.md": 106,
	"./wallet_terms_kh_KH.md": 107
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 169;


//////////////////
// WEBPACK FOOTER
// ./src/policies ^\.\/.*\.md$
// module id = 169
// module chunks = 0